/**
 * Sexy Hair — Before / After Image Comparison Slider
 *
 * Uses clip-path on the before image to reveal/hide it.
 * The after image sits underneath, both are full-width and never move.
 */
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-image-comparison]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function initSlider(slider) {
    var handle = slider.querySelector('.sexyhair-image-comparison__handle');
    var beforeImg = slider.querySelector('.sexyhair-image-comparison__image--before');
    if (!handle || !beforeImg) return;

    var dragging = false;

    // --- Mouse events ---
    handle.addEventListener('mousedown', onStart);
    slider.addEventListener('mousedown', onTap);
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onEnd);

    // --- Touch events ---
    handle.addEventListener('touchstart', onStart, { passive: false });
    slider.addEventListener('touchstart', onTap, { passive: false });
    document.addEventListener('touchmove', onMove, { passive: false });
    document.addEventListener('touchend', onEnd);

    // --- Keyboard ---
    handle.addEventListener('keydown', onKey);

    function onStart(e) {
      e.preventDefault();
      dragging = true;
    }

    function onTap(e) {
      var x = getX(e);
      if (x !== null) {
        dragging = true;
        updateFromX(x);
      }
    }

    function onMove(e) {
      if (!dragging) return;
      e.preventDefault();
      var x = getX(e);
      if (x !== null) updateFromX(x);
    }

    function onEnd() {
      dragging = false;
    }

    function onKey(e) {
      var current = parseFloat(handle.getAttribute('aria-valuenow')) || 50;
      var step = 2;
      if (e.key === 'ArrowLeft' || e.key === 'Left') {
        setPosition(Math.max(0, current - step));
      } else if (e.key === 'ArrowRight' || e.key === 'Right') {
        setPosition(Math.min(100, current + step));
      }
    }

    function getX(e) {
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      return clientX;
    }

    function updateFromX(clientX) {
      var rect = slider.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      setPosition(pct);
    }

    function setPosition(pct) {
      pct = Math.max(0, Math.min(100, pct));
      var clipRight = 100 - pct;
      beforeImg.style.clipPath = 'inset(0 ' + clipRight + '% 0 0)';
      handle.style.left = pct + '%';
      handle.setAttribute('aria-valuenow', Math.round(pct));
    }
  }
})();
